import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { invoiceListDemoData } from '../../../../../data/invoiceListDemoData';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import useApi from '../../../../hook/useApi';

const BillingUnauthorizedListContext = createContext();
export const useBillingUnauthorized = () => useContext(BillingUnauthorizedListContext);

function UnauthorizedListProvider({ children }) {
    const [reloadKey, setReloadKey] = useState(0);
    const [invoiceData, setInvoiceData] = useState(invoiceListDemoData);
    const [params, setParams] = useState({});
    const { setMessage } = useTemplate();
    const { get } = useApi();
    // -- Load invoice list data
    useEffect(() => {
        setInvoiceData({ unauthorizedInvoices: invoiceListDemoData, pagination: {} });
        if (Object.keys(params).length > 0) {
            get('api/invoices/unauthorized', params)
                .then(({ data, error }) => {
                    if (error) throw new Error(error);

                    setInvoiceData(data);
                })
                .catch((err) => {
                    setInvoiceData({ unauthorizedInvoices: [], pagination: {} });
                    setMessage({ type: 'error', text: err?.message || 'Failed to load data' });
                });
        }
    }, [reloadKey, params]);

    const value = useMemo(() => {
        // --Handle Reload
        const handleReload = () => {
            setReloadKey((d) => d + 1);
        };

        return {
            // Data filter data
            setParams,

            // Reload Key
            reloadKey,
            setReloadKey,
            // -- customer list
            invoiceData,
            setInvoiceData,

            // All Handler
            handleReload
        };
    }, [invoiceData, reloadKey]);

    return (
        <BillingUnauthorizedListContext.Provider value={value}>
            {children}
        </BillingUnauthorizedListContext.Provider>
    );
}

export default UnauthorizedListProvider;
